import util from '../util'

let controller = 'SolicitacaoDevolucao'
export default {
  Recebidas: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Recebidas', dto)
  },
  DetalhesDevolucao: function (id) {
    return util.Axios.Get(controller + '/DetalhesDevolucao', id)
  },
  Fechar: function (dto) {
    return util.Axios.Post(controller + '/Fechar' , dto)
  },
  CancelarSolicitacao: function (dto) {
    return util.Axios.Post(controller + '/Cancelar', dto)
  },
  ListarTodos: function (dto,options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/ListarTodosPixExternos', dto)
  },
  CriarSolicitacaoDevolucao: function (dto) {
    return util.Axios.Post(controller + '/CriarDevolucao', dto)
  },
  SolicitacoesEnviadas: function(dto, options){
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Solicitadas',dto)
  },
  DetalhesSolicitacaoDevolucao: function(id){
    return util.Axios.Get(controller + '/DetalhesSolicitacao',id)
  }
}